import { Variables } from '../../../styles/variables'
import styled from "styled-components";

export const Container = styled.div`
position: relative;
min-height: calc(100vh - 60px);
padding-bottom: 141px;

.section-header {
    margin-bottom: 28px;

    h2 {
        margin: 0 0 8px;
        font-size: 24px;
        line-height: 32px;
        font-weight: 600;
        color: #1C1B1F;
    }

    p {
        margin: 0;
        max-width: 720px;
        font-size: 14px;
        line-height: 20px;
        color: #516274;
    }
}

.fields-grid {
    .field-col-align {
        margin-bottom: 8px;
    }
}

.empty-state {
    padding: 24px;
    border-radius: 16px;
    background: #F4F7FA;
    color: #516274;
    font-size: 14px;
    line-height: 20px;
}

.select-networks {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 25px;

    .item {
        border: 3px solid #FFF;
        border-radius: 100px;

        &.selected {
            border: 3px solid ${Variables.yellow};
        }
    }
}

.ui {
    &.form {
        position: unset;

        .field {
            margin-bottom: 14px;
        }

        .footer {
            width: 100%;
            position: absolute;
            bottom: 28px;

            .btn-actions {
                display: flex;
            }
        }

        .ods-options {
            .ui.checkbox input:checked~label:after {
                top: 0;
                transform: translateY(50%);
            }

            label {
                display: flex;
                align-items: center;

                &:before {
                    top: 0;
                    transform: translateY(50%);
                }
                
                img {
                    width: 36px;
                    margin-right: 8px;
                }

                .text {
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 16px;
                    letter-spacing: 0.5px;
                    color: #000000;
                }
            }
        }
    }
}
`